import moment from "moment";
import { AvisConstants } from "../data/avisConstants";

export class TimeUtils {
  static millisecondsToHHMMSS(milliseconds?: number): string {
    if (!milliseconds) return "00:00:00";

    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
  static getMomentExactFormat(
    dateString: moment.MomentInput,
    format: string = AvisConstants.date_format,
  ): moment.Moment {
    return moment(dateString, format, true);
  }
  static formatUTCDateString(
    dateString?: string,
    format: string = AvisConstants.date_format,
  ): string {
    return moment(dateString).format(format);
  }

  static formatPeriod(
    dateFromUTC: string | undefined,
    dateToUTC: string | undefined,
  ): string {
    const dateFrom = this.formatUTCDateString(dateFromUTC);
    const dateTo = this.formatUTCDateString(dateToUTC);

    return `${dateFrom} - ${dateTo}`;
  }

  static isDate(possibleDate: any): boolean {
    return typeof possibleDate?.getMonth === "function";
  }
}
